import GalleryHelper from "GalleryHelper";
import Track from "util/Track";
import AjaxLoadedWebsiteModal from "modals/AjaxLoadedWebsiteModal";
import WebsiteModal from "modals/WebsiteModal";
import TouchGallery from "webPage/TouchGallery";
import {svg_include} from "index";

export default class GalleryModal extends WebsiteModal {
    constructor(page, galleryName, imageId = null, galleryType, videoUrl = null) {
        super();
        this.page = page;
        this.galleryName = galleryName;
        this.imageId = imageId;
        this.galleryType = galleryType;
        this.videoUrl = videoUrl;
    }

    buildElement() {
        this.$modal = AjaxLoadedWebsiteModal.global_settings.buildLoadingModal();

        this.buildGallery().catch((e) => {
            console.warn("Couldn't load gallery", e);
            if (this.destroyed) {
                return;
            }
            this.displayError(e);
        });
    }


    /**
     * @abstract
     * @returns {Promise<Object>}
     */
    async getGallery() {
        return GalleryModal.get_gallery(this.page, this.galleryName);
    }

    displayError(e) {
        this.$modal.find(".modal__container").append(
            eotwJSXFactory('div', {className: "message message--no-margin message--error"}, [
                eotwJSXFactory('p', null, [e.message])
            ]),
        );
        this.$modal.removeClass("modal--loading");
    }

    async buildGallery() {
        const gallery = await this.getGallery();
        const items = gallery.images;

        if (this.destroyed) {
            return;
        }

        let activeIndex = 0;

        // Get the index of the pre-selected image
        if (this.imageId !== null) {
            items.forEach((item, index) => {
                if (item.id === this.imageId) {
                    activeIndex = index;

                    // Ensure the image is preloaded and will load before any others
                    //noinspection JSUnusedLocalSymbols
                    const image = (
                        eotwJSXFactory('img', {sizes: "100vw", src: item.url, alt: item.alt})
                    );
                }
            });
        }

        this.$modal.addClass("modal--gallery").removeClass("modal--loading");
        this.$modal.find(".modal__container").remove();
        this.$modal.append(
            eotwJSXFactory('div', {className: "modal__container"}, [
                eotwJSXFactory('button', {type: "button", className: "modal__close js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__gallery"}, [
                    eotwJSXFactory('div', {className: "gallery js-gallery"}, [
                        eotwJSXFactory('div', {className: "gallery__main"}, [
                            eotwJSXFactory('div', {className: "gallery__main-wrap"}, [
                                eotwJSXFactory('div', {className: "gallery__main-wrap-inner js-items"}, [
                                    items.map((item, index) => (
                                        eotwJSXFactory('div', {'data-index': index, className: "gallery__main-image " + (index === activeIndex ? 'gallery__main-image--active' : '')}, [
                                            eotwJSXFactory('div', {className: "gallery__main-image-inner"}, [
                                                (() => {
                                                    switch (item.type) {
                                                        case 'video':
                                                            return eotwJSXFactory('video', {className: "js-gallery-video", controls: true, loop: true, muted: true}, [
                                                                eotwJSXFactory('source', {src: item.url, type: item.mime_type})
                                                            ]);
                                                        default:
                                                            return eotwJSXFactory('img', {width: item.width, height: item.height, src: item.src, srcSet: item.srcSet, alt: item.alt});
                                                    }
                                                })(),
                                                eotwJSXFactory('div', {className: "gallery__caption-text"}, [
                                                    eotwJSXFactory('h2', {className: "heading heading--5"}, [item.title]),
                                                    eotwJSXFactory('p', null, [item.caption])
                                                ])
                                            ])
                                        ])
                                    ))
                                ])
                            ])
                        ]),
                        eotwJSXFactory('div', {className: "gallery__controls"}, [
                            eotwJSXFactory('button', {type: "button", title: "Previous", 'data-direction': "backwards", 'aria-label': "Previous Image", className: "gallery__btn js-navigate", unsafeHtml: svg_include('hero-btn-arrow')}),
                            eotwJSXFactory('button', {type: "button", 'data-direction': "forwards", title: "Next", 'aria-label': "Next Image", className: "gallery__btn gallery__btn--next js-navigate", unsafeHtml: svg_include('hero-btn-arrow')})
                        ]),
                        eotwJSXFactory('div', {className: "gallery-thumbnails js-bottom-slider"}, [
                            eotwJSXFactory('div', {className: "gallery-thumbnails__inner-wrap js-pips js-outer-wrap"}, [
                                eotwJSXFactory('div', {className: "gallery-thumbnails__track js-track"}, [
                                    items.map((item, index) => (
                                        eotwJSXFactory('button', {type: "button", className: "js-track-item gallery-thumbnails__item " + (index === activeIndex ? "gallery-thumbnails__item--active" : ""), style: "background-image: url(" + item.boxSrc + ")"}, [
                                            eotwJSXFactory('span', {className: "gallery-thumbnails__item-active-state"}),
                                            eotwJSXFactory('img', {src: item.boxSrc, srcSet: item.boxSrcSet, sizes: "(max-width: 759px) 55px, (max-width: 1199px) 100px, (max-width: 1599px) 120px, 140px", alt: item.alt})
                                        ])
                                    ))
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
        );

        this.track = new Track(this.$modal.find('.gallery-thumbnails'), {
            classes: {
                block: "slider",
            },
        });

        this.touchGallery = new TouchGallery(this.$modal, {
            itemsClass: "gallery__main-wrap-inner",
            itemClass: "gallery__main-image",
            pipClass: "gallery-thumbnails__item",
            keyboardEvents: true,
            animationDuration: 300,
        });

        if (this.touchGallery.gallery.getItem(activeIndex).find('video').length > 0) {
            this.playSlideVideo(activeIndex);
        }

        this.touchGallery.on("transitionStart", ({from, to}) => {
            // We need to ensure that the element is within the viewport
            this.updateTrackOffset(to);
            // this.$modal.find('.js-gallery-numbers').text((to + 1) + '/' + items.length);
            this.pauseSlideVideo(from);
        }).on('transitionEnd', ({from, to}) => {
            this.playSlideVideo(to);
        });

        this.updateTrackOffset();

        this.emit(GALLERY_MODAL_LOADED);
        this.bindModalEvents();
    }

    updateTrackOffset(to = null) {
        if (to === null) {
            to = this.touchGallery.gallery.getActiveIndex();
        }
        let $to = this.track.getItems().eq(to);

        let offsetLeft = $to.position().left;
        let offsetRight = offsetLeft + $to.outerWidth() + 10;

        if (offsetLeft < this.track.getTransform()) {
            this.track.setTransform(offsetLeft - 0);
            return;
        }

        if (offsetRight > this.track.getTransform() + this.$modal.find('.js-bottom-slider').innerWidth()) {
            this.track.setTransform(offsetRight - this.$modal.find('.js-bottom-slider').innerWidth() + 10);
            return;
        }
    }

    destroy() {
        super.destroy();

        if (this.touchGallery) {
            this.touchGallery.destroy();
        }
    }

    static get_all_sizes_srcset(gallery, item) {
        return GalleryModal.get_sizes_srcset(gallery, item, Object.keys(item.sizes));
    }

    static get_sizes_srcset(gallery, item, sizes) {
        let srcSet = [];
        let srcSizes = [];
        sizes.forEach((key) => {
            key = key.replace('-width', '');
            key = key.replace('-height', '');
            if (srcSizes.indexOf(key) === -1) {
                srcSizes.push(key);
            }
        });
        srcSizes.forEach((size) => {
            if ('undefined' !== typeof item.sizes[size]) {
                srcSet.push(item.sizes[size] + ' ' + item.sizes[size + '-width'] + 'w');
            }

        });
        return srcSet.join(',');
    }

    static async get_gallery(page, galleryName) {
        return GalleryHelper.get_gallery(page, galleryName);
    }

    playSlideVideo(index) {
        if (this.touchGallery.gallery.getItem(index).find('.js-gallery-video').length === 0) {
            return;
        }
        let video = this.touchGallery.gallery.getItem(index).find('.js-gallery-video')[0];
        if (typeof video.play === "function") {
            video.play();
        }
    }

    pauseSlideVideo(index) {
        if (this.touchGallery.gallery.getItem(index).find('.js-gallery-video').length === 0) {
            return;
        }
        let video = this.touchGallery.gallery.getItem(index).find('.js-gallery-video')[0];
        if (typeof video.pause === "function") {
            video.pause();
        }
    }
}

export const GALLERY_MODAL_LOADED = 'galleryModalLoaded';
